import { render } from "./SponsorAddPage.vue?vue&type=template&id=6595fd8a&scoped=true"
import script from "./SponsorAddPage.vue?vue&type=script&lang=js"
export * from "./SponsorAddPage.vue?vue&type=script&lang=js"

import "./SponsorAddPage.vue?vue&type=style&index=0&id=6595fd8a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6595fd8a"]])

export default __exports__